export default {
  '90ac816d857bbd244c491943313396cc': 'Order confirmation counter - User agreement pop-up window',
  '0cefacbbe66660bed470586ecf1cb162': 'Please confirm you have read and agreed to the',
  d53798ced405bd77a839d0d4193c147b: '"User Service Agreement"',
  e03a7b37418172722525e17c8de3280b: '"Automatic Renewal Agreement"',
  '4cb2ee263648fa364d0ceaa27a8ef3a7': '"User Purchase Agreement"',
  '5dc192f57b70d0ab967759cd475ee2ed': 'Back',
  '6115eba37649fb1c1124157bbd77e7d1': 'Agree and continue'
};
